import { supabase } from '../core/supabase';

/**
 * Chamada às Edge Functions.
 *
 * Tudo que precisa de segredo (IA, e-mail, WhatsApp, webhooks) passa por aqui:
 * a chave fica no servidor e o navegador só recebe o resultado. O token do
 * usuário vai junto, então a função sabe quem é e de qual organização.
 */
export async function chamarFuncao<T>(
  nome: string,
  corpo: Record<string, unknown>,
): Promise<T> {
  if (!supabase) throw new Error('Supabase não configurado.');

  const { data, error } = await supabase.functions.invoke(nome, { body: corpo });

  if (error) {
    // O corpo do erro traz a mensagem em português vinda da função.
    const detalhe = await lerErro(error);
    throw new Error(detalhe);
  }

  const resposta = data as T & { error?: string };
  if (resposta && typeof resposta === 'object' && 'error' in resposta && resposta.error) {
    throw new Error(String(resposta.error));
  }
  return resposta;
}

async function lerErro(error: unknown): Promise<string> {
  const e = error as { context?: Response; message?: string };
  try {
    if (e.context) {
      const body = (await e.context.json()) as { error?: string };
      if (body?.error) return body.error;
    }
  } catch {
    // Sem corpo legível: cai na mensagem padrão.
  }
  if (e.message?.includes('Failed to fetch')) {
    return 'A função não respondeu. Verifique se as Edge Functions estão publicadas.';
  }
  return e.message ?? 'Falha ao chamar a função.';
}
